import { Search } from 'Constant';
import { fetchMainProgram } from 'Features/Learning/MainPrograms/Utils/MainProgramUtils';
import { fetchTestimonyProgram } from 'Features/Learning/TestimonyProgram/Utils/TestimonyProgramUtils';
import { attachDetachTestimonyProgram } from 'Features/Learning/TestimonyProgram/Utils/TestimonyProgramUtils';
import { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button, CardBody, Input, Modal, ModalBody, ModalFooter, ModalHeader, Table } from 'reactstrap'
import Swal from 'sweetalert2';
import { handleBackPagination, handleClickPagination, handleNextPagination } from "Component/Learning/MainProgram/MainProgramUtils";
import PaginationComponent from "Component/Learning/Common/Pagination";
import { setFilters } from 'Features/Learning/MainPrograms/mainProgramSlice';
import { useNavigate } from 'react-router';

const ModalProgram = ({ id, mainPrograms }) => {
  const navigate = useNavigate();
  const [openProgram, setOpenProgram] = useState(false);
  const [dataProgram, setDataProgram] = useState([]);
  const [search, setSearch] = useState('');
  const [isLoadingProgram, setIsLoadingProgram] = useState(false);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const filters = useSelector(state => state.MainProgram.filters)
  const isLoading = useSelector(state => state.MainProgram.isLoading)
  const pagination = useSelector((state) => state.MainProgram.data.pagination);
  const dispatch = useDispatch();
  const [refatch, setRefatch] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  // snapshot selection saat modal dibuka (dipakai untuk restore / detect perubahan)
  const initialSelectedRef = useRef([]);

  useEffect(() => {
    dispatch(fetchMainProgram({ ...filters }))
      .then((response) => {
        setDataProgram(response?.payload?.data)
      })
      .catch((error) => {
        console.error('Error fetching options:', error);
      });
  }, [dispatch, filters, refatch])

  const handleClickSearch = () => {
    setRefatch(!refatch);
  };

  const updateSearchParams = useCallback(() => {
    dispatch(
      setFilters({
        ...filters,
        "filter[title]": search,
        "page": 1
      })
    );
  }, [search]);

  useEffect(() => {
    const delay = setTimeout(updateSearchParams, 500);
    return () => clearTimeout(delay);
  }, [search, updateSearchParams]);

  const handleCheckboxChange = (item) => {
    if (selectedIds.includes(item.id)) {
      setSelectedIds(selectedIds.filter(id => id !== item.id));
    } else {
      setSelectedIds([...selectedIds, item.id]);
    }
  };

  const handleSelectAll = () => {
    if (isSelectAll) {
      // Unselect all yang ada di halaman ini
      const newSelectedIds = selectedIds.filter(id => !dataProgram.some(item => item.id === id));
      setSelectedIds(newSelectedIds);
    } else {
      // Select all yang ada di halaman ini
      const newSelectedIds = [
        ...selectedIds,
        ...dataProgram.map(item => item.id).filter(id => !selectedIds.includes(id))
      ];
      setSelectedIds(newSelectedIds);
    }
  };

  useEffect(() => {
    setIsSelectAll(
      dataProgram.length > 0 &&
      dataProgram.every(item => selectedIds.includes(item.id))
    );
  }, [selectedIds, dataProgram]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingProgram(true);

    if (selectedIds.length === 0) {
      Swal.fire({ icon: 'error', title: 'Oops...', text: 'Pilih minimal satu program.' });
      setIsLoadingProgram(false);
      return;
    }

    try {
      const action = await dispatch(attachDetachTestimonyProgram({
        id,
        main_program_ids: selectedIds
      }));

      if (action.error) throw action.error;

      await dispatch(fetchTestimonyProgram({
        "filter[id]": id,
        page: 1,
        include: "staticAssets,mainPrograms"
      }));

      setIsLoadingProgram(false);
      setOpenProgram(false);
      navigate(`${process.env.PUBLIC_URL}/testimony-program/detail/${id}`);
    } catch (err) {
      setIsLoadingProgram(false);
      Swal.fire({ icon: 'error', title: 'Terjadi kesalahan', text: err?.message || 'Gagal menyimpan perubahan.' });
    }
  };

  const handleToggle = async () => {
    const items = Array.isArray(mainPrograms) ? mainPrograms : [];
    // open -> prepare initial snapshot (union existing selectedIds + mainPrograms)
    if (!openProgram) {
      const initial = Array.from(new Set([...(selectedIds || []), ...items.map(i => i.id)]));
      initialSelectedRef.current = initial;
      setSelectedIds(initial);
      setOpenProgram(true);
      return;
    }

    // closing -> check perubahan terhadap snapshot, minta konfirmasi bila berubah
    const initialIds = (initialSelectedRef.current || []).slice().sort().join(",");
    const currentIds = (selectedIds || []).slice().sort().join(",");

    if (initialIds !== currentIds) {
      const result = await Swal.fire({
        title: "Perubahan belum disimpan",
        text: "Perubahan yang belum disimpan akan dibatalkan. Lanjutkan?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Ya",
        cancelButtonColor: "#d33",
      });
      if (!result.isConfirmed) return;
    }

    // restore ke snapshot dan tutup modal
    setSelectedIds(initialSelectedRef.current || []);
    setOpenProgram(false);
  };

  return (
    <>
      <Button color="success" disabled={isLoadingProgram} onClick={handleToggle} style={{ padding: '0px 12px' }}>
        <i className="fa fa-solid fa-file me-2"></i>
        {isLoadingProgram ? "Memproses..." : "Tambah Program"}
      </Button>

      <Modal isOpen={openProgram} size="lg">
        <ModalHeader toggle={handleToggle}>
          Tambahkan Programs ke Testimony
        </ModalHeader>
        <ModalBody>
          <ul>
            {selectedIds.length > 0 &&
              selectedIds.map((id, index) => {
                const program = dataProgram.find(item => item.id === id);
                return (
                  <li key={`item-${id}`}>
                    {program ? `${program.id} - ${program.title}` : id}
                  </li>
                );
              })}
          </ul>
          <div className="faq-form mt-3">
            <Input
              className="form-control"
              type="text"
              placeholder="Search.."
              value={search}
              onKeyUp={(e) => (e.key === "Enter" ? handleClickSearch(e) : null)}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Search className="search-icon" />
          </div>
          <Table className="table-responsive table-bordered my-3">
            <thead className="table-light">
              <tr>
                <th scope="col">{"#"}</th>
                <th scope="col">{"ID"}</th>
                <th scope="col">Nama Programs</th>
                <th scope="col" className="text-center" colSpan="2">
                  <Input
                    className="checkbox_animated"
                    id={`selectAll`}
                    type="checkbox"
                    checked={selectedIds.length > 0 && isSelectAll}
                    onChange={handleSelectAll}
                  />
                </th>
              </tr>
            </thead>
            <tbody>
              {dataProgram && dataProgram.map((item, index) => (
                <tr key={`item-${item.id}`}>
                  <th>{pagination?.from + index}</th>
                  <th>{item.id}</th>
                  <td>{item.title}</td>
                  <td className="text-center">
                    <Input
                      className="checkbox_animated"
                      type="checkbox"
                      checked={selectedIds.includes(item.id)}
                      onChange={() => handleCheckboxChange(item)}
                    />
                  </td>
                </tr>
              )
              )}
            </tbody>
          </Table>
          <CardBody>
            {(isLoading === false && pagination) && (
              <PaginationComponent
                pagination={pagination}
                handleBackPagination={() => handleBackPagination(pagination, filters, dispatch, setFilters, setRefatch)}
                handleClickPagination={(page) => handleClickPagination(page, filters, dispatch, setFilters, setRefatch)}
                handleNextPagination={() => handleNextPagination(pagination, filters, dispatch, setFilters, setRefatch)}
              />
            )}
          </CardBody>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleToggle}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSubmit}>
            Save
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default ModalProgram;